import React, { useState, useRef } from 'react';
import AvatarEditor from 'react-avatar-editor';
import { X } from 'phosphor-react';
import { SButton } from '@/components/ui/atoms/SButton';
import './AvatarZoomModal.css';

export interface AvatarZoomModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageFile: File | null;
  onSave: (croppedImage: Blob) => void;
}

export const AvatarZoomModal: React.FC<AvatarZoomModalProps> = ({
  isOpen,
  onClose,
  imageFile,
  onSave,
}) => {
  const editorRef = useRef<AvatarEditor>(null);
  const [scale, setScale] = useState(1.2);

  const handleZoomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setScale(Number(e.target.value));
  };

  const handleSave = async () => {
    if (!editorRef.current) return;

    const canvas = editorRef.current.getImageScaledToCanvas();
    canvas.toBlob((blob: Blob | null) => {
      if (blob) {
        onSave(blob);
        onClose();
      }
    }, 'image/jpeg', 0.9);
  };

  if (!isOpen || !imageFile) return null;

  return (
    <div className="avatar-zoom-overlay">
      <div className="avatar-zoom-modal">
        {/* Header */}
        <div className="avatar-zoom-header">
          <h2 className="avatar-zoom-title">Adjust Photo</h2>
          <button className="avatar-zoom-close" onClick={onClose}>
            <X size={24} color="#111215" />
          </button>
        </div>

        {/* Image Container with AvatarEditor */}
        <div className="avatar-zoom-container">
          <AvatarEditor
            ref={editorRef}
            image={imageFile}
            width={200}
            height={200}
            border={30}
            borderRadius={120}
            color={[255, 255, 255, 0.6]}
            scale={scale}
            rotate={0}
          />
        </div>

        {/* Zoom Slider */}
        <div className="avatar-zoom-controls">
          <label className="avatar-zoom-label">Zoom</label>
          <input
            type="range"
            min="1"
            max="3"
            step="0.01"
            value={scale}
            onChange={handleZoomChange}
            className="avatar-zoom-slider"
          />
        </div>

        {/* Actions */}
        <div className="avatar-zoom-actions">
          <SButton
            variant="outline"
            size="lg"
            label="Cancel"
            onClick={onClose}
            className="avatar-zoom-cancel-btn"
          />
          <SButton
            variant="primary"
            size="lg"
            label="Save"
            onClick={handleSave}
            className="avatar-zoom-save-btn"
          />
        </div>
      </div>
    </div>
  );
};

export default AvatarZoomModal;
